module.exports = __webpack_public_path__ + "static/icons/icon-user-69f4d82f0eb19e243b614148ded88e24.svg";